<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                flat
                dark
              >
                <v-toolbar-title>E-mail Change Form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="email"
                    label="E-mail"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="newEmail"
                    label="New E-mail"
                    name="newEmail"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="token"
                    label="Token (optional)"
                    name="token"
                    prepend-icon="mdi-check"
                    type="token"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="resetRequest()" color="secondary">Request Token</v-btn>
                <v-btn @click="reset()" color="secondary">Reset E-mail</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import { CHANGE_EMAIL_USER_REQUEST_MUTATION, CHANGE_EMAIL_USER_MUTATION } from '../../graphql/authenticationQueries.js';

  export default {
    props: {
      source: String,
    },
    data () {
      return {
        email: null,
        newEmail: null,
        token: null,
      }
    },
    apollo: {
      $client: 'authenticationClient'
    },
    methods: {
      async resetRequest(){
        const { email } = this.$data;
        try {
          const result = await this.$apollo.mutate({
            mutation: CHANGE_EMAIL_USER_REQUEST_MUTATION,
            variables: {
              email: email
            }
          });
          
          if (result.data.changeEmailUserRequest === true) {
              alert("Check your e-mail inbox for one time token");
          }
        } catch (error) {
          alert(`Error trying to change email for user '${email}'`);
        }
        
      },

      async reset(){
        const { email, newEmail, token } = this.$data;
        try {
          const result = await this.$apollo.mutate({
            mutation: CHANGE_EMAIL_USER_MUTATION,
            variables: {
              email: newEmail,
              token: token
            }
          });
          
          if (result.data.changeEmailUser && result.data.changeEmailUser.email === newEmail) {
            alert(`Email successfully changed from '${email}' to '${newEmail}' !`);
          }
        } catch (error) {
          alert(`Error trying to change email from '${email}' to '${newEmail}'`);
        }
        
      }
    }
  }
</script>